import { css } from '@emotion/react';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import type { PropsWithChildren } from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { warningColorStyle } from '~/_shared/baseComponents/warning/warning.styles';

const blockWarningStyle = [warningColorStyle, css({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
})];

type BlockWarningProps = {
  icon?: typeof faCircleExclamation;
};

export const BlockWarningComponent = ({
  children,
  icon = faCircleExclamation,
}: PropsWithChildren<BlockWarningProps>) => {
  return (
    <div css={blockWarningStyle}>
      <FontAwesomeIcon
        icon={icon}
        size="lg"
      />
      <div>
        {children}
      </div>
    </div>
  );
};
